import { http } from '../../http';
import Apps from '../../../core/Apps';
import filter from "lodash/filter";
import sortBy from 'lodash/sortBy';

export default {
    state: {
        surveyRequests: [],
        loaded: false,
        loading: false,
        client_id : 0,
    },

    mutations: {
        setSurveyRequests(state, surveyRequests = null) {
            state.surveyRequests = surveyRequests || [];
        },
    },

    getters: {
        loading: (state, getters) => {
            return state.loading;
        },

        all: (state, getters) => {
            return filter(state.surveyRequests, (sr) => { return sr.client_id === state.client_id; });
        },

        allSorted: (state, getters) => {
            const sortedBySentAt = sortBy(
                getters.all, (sr) => new Date(sr.sent_at)
            ).reverse();
            return sortBy(sortedBySentAt, (sr) => sr.sent_at).reverse();
        },

        isLoaded(state, getters) {
            return state.loaded;
        },
    },

    actions: {
        load ({ commit, state, rootGetters }, client_id) {

            //Don't reload if it is the same client that is requested
            if ((state.loaded && client_id === state.client_id) || state.loading) {
                return;
            }

            state.client_id = client_id;
            state.loading = true;

            if ( ! rootGetters['apps/isAppEnabled'](Apps.Surveys)) {
                state.loaded = true;
                state.loading = false;
                return;
            }

            http.get('/app/client/'+client_id+'/survey-requests')
                .then(({ data }) => {
                    commit('setSurveyRequests', data.surveyRequests);
                    state.loaded = true;
                    state.loading = false;
                }).catch(() => {
                    state.loading = false;
                });
        },

        reload({ state, dispatch }, client_id) {
            state.loaded = false;
            dispatch('load', client_id);
        },

        resetSubmissionWithPrompt({ dispatch }, surveyRequest, swalOptions = {}) {
            const options = {
                title: trans('surveys.delete_survey_answers_title'),
                text: trans('surveys.delete_survey_answers_text'),
                showCancelButton: true,
                cancelButtonText: trans('global.cancel'),
                confirmButtonText: trans('surveys.delete_survey_answers_confirm_text'),
                closeOnConfirm: true,
                ...swalOptions
            };
            return new Promise((resolve, reject) => {
                swal(options, (confirm) => {
                    if (!confirm) {
                        return;
                    }
                    dispatch('resetSubmission', surveyRequest)
                        .then((response) => {
                            resolve(response);
                        })
                        .catch((error) => {
                            reject(error);
                        });
                });
            });
        },

        resetSubmission({ state, dispatch }, surveyRequest) {
            return new Promise((resolve, reject) => {
                http.post([
                    '/app/survey-requests/',
                    surveyRequest.id,
                    '/destroy'
                ].join(''))
                        .then(({data}) => {
                            dispatch('reload', surveyRequest.client_id);
                            resolve(data);
                        })
                        .catch(({error}) => {
                            reject(error);
                        });
            });
        },
    }
};
